import { deepClone } from './commonUtils';

export const convertStyleData = (querydatas) => {
  const queryClone = deepClone(querydatas);

  if (queryClone.length) {
    return queryClone.map((data) => {
      data.id = undefined;
      data.__typename = undefined;
      data._audioData = data._audioData?.id;
      data._videoData = data._videoData?.id;
      data._imageData = data._imageData
        ? Array.isArray(data._imageData)
          ? data._imageData.map((image) => image?.id)
          : data._imageData?.id
        : [];

      if (data.lyricsData) {
        for (let i = 0; i < data.lyricsData.length; i++) {
          for (let j = 0; j < data.lyricsData[i].length; j++) {
            data.lyricsData[i][j].__typename = undefined;
            data.lyricsData[i][j]._img = data.lyricsData[i][j]._img?.id;
          }
        }
      }

      return data;
    });
  }
};

export const encodeMediaKey = (key) => {
  if (typeof key !== 'string') return key;
  return encodeURI(key).replace(/\+/g, '%2B');
};

const pickMediaKey = (media, keytype) => {
  const instanceKey = Array.isArray(keytype)
    ? keytype.reduce((t, v) => t ?? media[v], undefined)
    : media[keytype];
  return instanceKey || media.key;
};

// Full URLs in server-preferred order. `mediaHosts` is the opt-in list the
// backend resolves (lead with the first entry, try the next only after a
// load actually fails); objects without it — upload responses, previously
// cached queries — degrade to a single-entry list from the legacy `domain`.
export const extractMediaList = (media, keytype = 'key') => {
  if (!media) return [];
  const key = pickMediaKey(media, keytype);
  if (!key) return [];
  const hosts = (
    media.mediaHosts?.length ? media.mediaHosts : [media.domain].flat()
  ).filter(Boolean);
  const keyStr = encodeMediaKey(key);
  return [...new Set(hosts)].map((host) => host + keyStr);
};

export const extractMedia = (media, keytype = 'key') => {
  if (media) {
    const { domain } = media;
    const key = pickMediaKey(media, keytype);
    // Lead with the server-ordered mediaHosts when present, so every
    // extractMedia caller follows the site-aware routing (io site + old
    // file → IO CDN; new files and the cn site stay on CN). Objects
    // without the field — upload responses, previously cached queries —
    // keep the legacy `domain` behaviour.
    const host = media.mediaHosts?.length ? media.mediaHosts[0] : domain;

    if (host && key) {
      const keyStr = encodeMediaKey(key);
      if (Array.isArray(host)) {
        // TODO: this is quick fix to use when sync the s3 to china
        return {
          src:    host[0] + keyStr,
          srcSet: host[1] + keyStr,
        };
      } else {
        return host + keyStr;
      }
    }
  }

  return undefined;
};

export const dataURItoBlob = (dataURI) => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
};
